<template lang="pug">
  .tooltip(:class="`rarity-${item.rarity}`")
    .tooltip__header(v-html="item.name")
    .tooltip__wrap
      .tooltip__item
        .tooltip__item__image
          img(:src="getImageUrl")
        .tooltip__item__info
          .tooltip__item__type {{ item.item_type }}
          .tooltip__item__notice {{ item.item_notice }}
      .tooltip__info
        .tooltip__info__level(v-if="item.level") {{ item.level_label }}
          span {{ item.level }}
        .tooltip__info__condition {{ item.condition }}
        .tooltip__info__description(v-html="item.description")
        .tooltip__info__warning(v-html="item.warning")
</template>

<script>
export default {
  name: "ItemTooltip",

  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getImageUrl() {
      return require(`@/assets/images/prizes/old/${this.item.image}.png`);
    },
  },
};
</script>
